var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    d: "M8.86.79a11.865 11.865 0 0 0 .812 22.668c1.988.513 4.07.536 6.068.066A10.7 10.7 0 0 0 20.596 21a10.77 10.77 0 0 0 3-4.924 13.9 13.9 0 0 0 .302-6.296h-11.16v4.63h6.463a5.57 5.57 0 0 1-2.373 3.66 6.8 6.8 0 0 1-2.612 1.03 7.7 7.7 0 0 1-2.832 0 7 7 0 0 1-2.634-1.149 7.37 7.37 0 0 1-2.719-3.64 7.18 7.18 0 0 1 0-4.62 7.36 7.36 0 0 1 1.721-2.795 6.97 6.97 0 0 1 7.022-1.833 6.4 6.4 0 0 1 2.558 1.5q1.093-1.087 2.182-2.181c.375-.392.784-.765 1.154-1.166A11.5 11.5 0 0 0 16.85.86 12 12 0 0 0 8.86.789"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#E33629",
    d: "M8.86.79a12 12 0 0 1 7.99.069 11.5 11.5 0 0 1 3.816 2.366c-.375.401-.771.776-1.154 1.166q-1.09 1.09-2.18 2.171a6.4 6.4 0 0 0-2.558-1.5A6.97 6.97 0 0 0 7.751 6.89a7.36 7.36 0 0 0-1.722 2.795L2.143 6.675A11.9 11.9 0 0 1 8.86.789"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#F8BD00",
    d: "M1.111 9.656a11.8 11.8 0 0 1 1.032-2.981l3.886 3.017a7.18 7.18 0 0 0 0 4.618q-1.942 1.5-3.886 3.015A11.87 11.87 0 0 1 1.11 9.656"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#587DBD",
    d: "M12.738 9.778h11.16a13.9 13.9 0 0 1-.302 6.296 10.77 10.77 0 0 1-3 4.924c-1.254-.979-2.514-1.95-3.768-2.929a5.57 5.57 0 0 0 2.373-3.663h-6.463q-.002-2.313 0-4.628"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#319F43",
    d: "M2.14 17.325q1.946-1.5 3.887-3.015a7.37 7.37 0 0 0 2.723 3.641c.791.56 1.69.948 2.64 1.14a7.7 7.7 0 0 0 2.831 0 6.8 6.8 0 0 0 2.612-1.03c1.255.978 2.515 1.95 3.769 2.928a10.7 10.7 0 0 1-4.856 2.525c-1.998.47-4.08.448-6.068-.065a11.8 11.8 0 0 1-4.312-2.173 11.94 11.94 0 0 1-3.225-3.95"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgGoogle;